import React, { Component } from 'react';

export class MockBar extends Component{
  render (){
    return(
      <span className="Feature__Bar">
        <span className="r"></span>
        <span className="y"></span>
        <span className="g"></span>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FeatureBar.js